import React, { useState } from 'react';
import CategoryBarGraph from '../components/CategoryBarGraph.js';

const GraphsPage = () => {
  const [error, setError] = useState(null);

  return (
    <div className="GraphsPage">
      <h1>App Performance Analysis</h1>
      <div className="graph-container">
        {error ? (
          <p>Error loading graph: {error}</p>
        ) : (
          <CategoryBarGraph onError={setError} />
        )}
      </div>
    </div>
  );
};

export default GraphsPage;
